<template>
  <div class="project-modal">
    <div class="modal fade" data-bs-backdrop="static" id="projectDeleteModal" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" v-draggable-modal>
        <div v-if="elementType" class="modal-content bg-primary">

          <div class="modal-header">
            <div class="h5 modal-title text-light">
              <span v-if="elementType === 'project'"> {{ $t("views.project.edit.headingDeleteProject") }} </span>
              <span v-if="elementType === 'member'"> {{ $t("views.project.edit.headingDeleteMember") }} </span>
              <span v-if="elementType === 'review'"> {{ $t("views.project.edit.headingDeleteReview") }} </span>
              <span v-if="elementType === 'measure'"> {{ $t("views.project.edit.headingDeleteMeasure") }} </span>
            </div>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <div class="modal-body bg-light">
            <div v-if="elementType === 'project'" class="text-center my-3">
              <p class="fw-bold">{{ this.selectedProject.name }}</p>
              <p> {{ $t("views.project.edit.confirmDeleteProject") }}</p>
              <p> {{ $t("views.project.edit.infoDelete") }}</p>
            </div>
            <div v-if="elementType === 'member'" class="text-center my-3">
              <p class="fw-bold"> {{ this.projectModalElementName }}</p>
              <p> {{ $t("views.project.edit.confirmDeleteMember") }}</p>
            </div>
            <div v-if="elementType === 'review'" class="text-center my-3">
              <p class="fw-bold"> {{ this.projectModalElementName }}</p>
              <p> {{ $t("views.project.edit.confirmDeleteReview") }}</p>
            </div>
            <div v-if="elementType === 'measure'" class="text-center my-3">
              <p class="fw-bold"> {{ this.projectModalElementName }}</p>
              <p> {{ $t("views.project.edit.confirmDeleteMeasure") }}</p>
            </div>
          </div>

          <div class="modal-footer bg-light">
            <button type="button" class="btn btn-sm btn-outline-secondary" data-bs-dismiss="modal">{{ $t("general.close") }}</button>
            <button @click="deleteElement()" type="button" class="btn btn-sm btn-danger" data-bs-dismiss="modal">{{ $t("general.delete") }}</button>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProjectDeleteModal',
  mounted () {
    const myModalDialog = document.getElementById('projectDeleteModal')

    myModalDialog.addEventListener('shown.bs.modal', event => {
      this.projectModalElementName = this.$parent.projectModalElementName
    })
  },
  data () {
    return {
      projectModalElementName: ''
    }
  },
  computed: {
    selectedProject () {
      return this.$store.state.selectedProject
    },
    elementId () {
      return this.$parent.projectModalElementId
    },
    elementType () {
      return this.$parent.projectModalElementType
    }
  },
  methods: {
    async deleteElement () {
      try {
        this.$store.commit('SET_LOADING_STATUS', true)
        if (this.elementType === 'project' && !this.selectedProject.hasNodes) {
          await this.$store.dispatch('deleteProject', this.selectedProject.id)
        } else {
          await this.$store.dispatch('deleteProjectElement', { projectId: this.selectedProject.id, elementType: (this.elementType + 's'), elementId: this.elementId })
        }
      } finally {
        this.$store.commit('SET_LOADING_STATUS', false)
      }

      // Reload Data & Treeview
      if (this.elementType === 'review') {
        await this.$store.dispatch('getProjects', { validFrom: this.$parent.filterValidFrom, validTo: this.$parent.filterValidTo })
      }
    }
  }
}
</script>
